import { Location } from 'history'
import { FrontUrls, WHITE_LIST_URLS } from 'Constants/FrontUrls'

export const isPage_403 = (entries: any[], location: Location): boolean => {
	let currentPath = location.pathname.replace(/[\d]/g, '').replace(/\/\//g, '/')
	// случай, когда у нас после обрезания адреса в статьях базы знаний остается последних "//"
	currentPath =
		currentPath !== FrontUrls.root && currentPath.slice(-1) === '/'
			? currentPath.slice(0, -1)
			: currentPath
	const isActive = entries.find((part): boolean => currentPath === part?.url && part?.active)
	const parentPath = isActive ? currentPath : `/${currentPath.split('/')[1]}`
	const parentPath2 = isActive ? currentPath : `/${currentPath.split('/').slice(1, -1).join('/')}`
	const isPage404 = location.pathname === FrontUrls.pages.page_404
	const isPage500 = location.pathname === FrontUrls.pages.page_500

	return (
		!isPage404 &&
		!isPage500 &&
		currentPath !== FrontUrls.root &&
		currentPath !== FrontUrls.pages.page_403 &&
		!WHITE_LIST_URLS.includes(currentPath) &&
		!isActive &&
		!entries.find((part): boolean => parentPath === part?.url && part?.active) &&
		!entries.find((part): boolean => parentPath2 === part?.url && part?.active)
	)
}

export const SvgLibrary = JSON.parse(process.env.SVG_NAMES)
export const hasInIconLibrary = (name: string) => new Set(SvgLibrary.result).has(name)
